import { FormattedMessage, useIntl } from 'react-intl';
import { JRCModal } from '../../../JRCModal/templates/JRCModal';
import * as React from 'react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { ImageSize } from 'jamespot-user-api';
import { JRCInputImage } from '../JRCInputImage/JRCInputImage';
import styled, { useTheme } from 'styled-components';
import { JRCModalButtonType } from '../../../JRCModal/JRCModalContent';

type JRCTinyMCEImageUploadModalProps = {
    closeHandler: () => void;
    open: boolean;
    token?: string;
};

const InputImageWrapper = styled.div`
    width: 50%;
    margin: 0 auto 20px auto;
`;

type ImageFormValues = { image: { type: string; id: number; timestamp: string; imagesize?: ImageSize } };
export const JRCTinyMCEImageUploadModal = ({ open, closeHandler, token }: JRCTinyMCEImageUploadModalProps) => {
    const intl = useIntl();
    const theme = useTheme();
    const form = useForm<ImageFormValues>();

    const closeModal = useCallback(() => {
        closeHandler();
        form.reset();
    }, [form, closeHandler]);

    const saveImage = useCallback(() => {
        const image = form.watch('image');
        tinymce.activeEditor.insertContent(`<img src='/media/${image.id}.png' />`);
        tinymce.activeEditor.windowManager.close();
        closeHandler();
    }, [form, closeHandler]);

    let buttons: JRCModalButtonType[] = [
        {
            children: <FormattedMessage id="GLOBAL_Cancel" />,
            color: 'cancel',
            clickHandler: closeModal,
        },
    ];
    if (form.watch('image')) {
        buttons = [
            ...buttons,
            {
                children: <FormattedMessage id="GLOBAL_Save" />,
                color: 'valid',
                clickHandler: saveImage,
            },
        ];
    } else {
        buttons = [
            ...buttons,
            {
                children: <FormattedMessage id="GLOBAL_Save" />,
                color: 'valid',
                clickHandler: saveImage,
                disabled: true,
            },
        ];
    }

    return (
        <JRCModal
            open={open}
            closeHandler={closeModal}
            zIndex={theme.zIndex.tinyMCEModal}
            title={intl.formatMessage({ id: 'GLOBAL_Add_Image' })}
            buttons={buttons}
            enableClickAwayCloseModal={false}>
            <InputImageWrapper>
                <JRCInputImage
                    zIndex={theme.zIndex.tinyMCEModal}
                    control={form.control}
                    name={'image'}
                    token={token}
                    attrName={'editorFiles'}
                    accept={'jpg,jpeg,png,gif'}
                    allowCustomRatio
                />
            </InputImageWrapper>
        </JRCModal>
    );
};
